import http from 'plugins/axios';

export default {
  getLogList() {
    return http.post({
      url: '/admin/st/log/monitor/search'
    });
  }
};
